import {FC, useEffect, useRef, useState} from "react";
import {Container, MainContent} from "../styles";
import SidebarCardHeader from "../../SidebarCardHeader";
import {SearchInputCustom} from "../../../ui/SearchInputCustom";
import {ResultSearchContentSidebarCard} from "../../Sidebar/styles";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {SidebarTab} from "../../Sidebar/SidebarSearch";
import {SidebarCardSearchEsgItem} from "./SidebarCardSearchEsgItem";
import {SidebarCardSearchStateInitiativeItem} from "./SidebarCardSearchStateInitiativeItem";

interface IProps {
  onCloseCard: () => void;
  typeRadar: ITypeRadar;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar
  ) => void;
  searchDatasidebarInfo?: IDataForSearchSidebar;
}

interface IResultFindEsg {
  id: string | number;
  name: string;
  clusters: {
    id: string | number;
    name: string;
  }[];
}

export const SidebarCardSearchStateInitiative: FC<IProps> = ({
  onCloseCard,
  typeRadar,
  openSidebarWithTab,
  searchDatasidebarInfo,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputSearchValue, setInputSearchValue] = useState("");

  const [resultSearchFind, setResultSearchFind] = useState(
    {} as IResultFindEsg[]
  );

  const [isShowTitleParams, setIsShowTitleParams] = useState(true);

  const handleTypeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearchValue(event.target.value);
  };

  useEffect(() => {
    const resultsFindClusters = searchDatasidebarInfo?.clusters?.filter(
      (item) => item.name.toLowerCase().includes(inputSearchValue.toLowerCase())
    );
    const groupedResults: IResultFindEsg[] =
      searchDatasidebarInfo?.directions?.reduce(
        (acc: IResultFindEsg[], direction) => {
          const clusters = resultsFindClusters?.filter(
            (cluster) => cluster.direction_id === direction.documentId
          );

          if (clusters && clusters.length > 0) {
            acc.push({
              id: direction.id,
              name: direction.name,
              clusters: clusters.map((cluster) => ({
                id: cluster.id,
                name: cluster.name,
              })),
            });
          }

          return acc;
        },
        []
      ) ?? [];

    setResultSearchFind(groupedResults);
  }, [inputSearchValue, searchDatasidebarInfo]);

  return (
    <Container>
      <SidebarCardHeader
        previewTitle="Радар: «ЦРГЦИ»"
        title="ПОИСК ПО СТЕЙКХОЛДЕРАМ"
        colorTitle="#53C6F5"
        onClose={onCloseCard}
        color="#858E97"
      />
      <MainContent>
        <SearchInputCustom
          searchInputRef={searchInputRef}
          inputSearchValue={inputSearchValue}
          handleTypeSearch={handleTypeSearch}
          setInputSearchValue={setInputSearchValue}
        />

        {/* {inputSearchValue.length > 0 && ( */}
        <div
          style={{
            color: "#fff",
            padding: "5px 0",
            zIndex: 1,
          }}
        >
          {resultSearchFind.length > 0 ? (
            <div>
              <p
                style={{
                  color: "rgba(255,255,255,0.6)",
                  fontSize: "16px",
                  margin: "20px 0 10px",
                }}
              >
                Результаты:
              </p>

              <ResultSearchContentSidebarCard>
                <div>
                  {resultSearchFind.map((item) => {
                    return (
                      <SidebarCardSearchStateInitiativeItem
                        key={item.id}
                        id={item.id}
                        name={item.name}
                        searchDatasidebarInfo={item}
                        isShowTitleParams={isShowTitleParams}
                        typeRadar={typeRadar}
                        openSidebarWithTab={openSidebarWithTab}
                      />
                    );
                  })}
                </div>
              </ResultSearchContentSidebarCard>
            </div>
          ) : (
            <div
              style={{
                padding: "5px 10px",
                borderBottom: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              Ничего не найдено
            </div>
          )}
        </div>
        {/* )} */}
      </MainContent>
    </Container>
  );
};
